/**
 * Custom js from legacy main.js
 *
 */
/**
 * Require $.
 */
 var $ = require('jquery');

 module.exports = function () {
 $(".sub-menu .dropdown-toggle").on("click", function(e) {
    item2 = [];
    $(".sub-menu .dropdown-toggle.open").each(function(index, item) {
      item2 = item;
      $(item).removeClass("open");
      $(item)
        .next(".dropdown-menu")
        .fadeToggle(500);
    });
    e.preventDefault();
    if (item2 != this) {
      $(this).addClass("open");
      $(this)
        .next(".dropdown-menu")
        .fadeToggle(500);
    }
  });
  
  /*
   ***Block: My account page
   ***Author: Yichen Zhao
   ***Last updated: 09/06/2018
   */
  
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  
  var billing_dialog, billing_form, shipping_dialog;
  billing_dialog = $("#update-billing-dialog-form").dialog({
    autoOpen: false,
    height: 700,
    width: "auto",
    modal: true
  });
  
  shipping_dialog = $("#update-shipping-dialog-form").dialog({
    autoOpen: false,
    height: 700,
    width: "auto",
    modal: true
  });
  
  function updateUserInfo() {
    var data = {};
    $("#gform_1")
      .serializeArray()
      .map(function(x) {
        data[x.name] = x.value;
      });
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "dc360_update_user_info",
        update_data: data
      },
      success: function(data) {
        location.reload();
      },
      fail: function(data) {
        alert(
          "We're sorry, but there was an error processing your request. Please refresh the page and try again. If the issue persists, please contact support."
        );
        location.reload();
      }
    });
  }
  
  function updateUserShipping() {
    var data = {};
    $("#gform_2")
      .serializeArray()
      .map(function(x) {
        data[x.name] = x.value;
      });
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "dc360_update_shipping_address",
        update_data: data
      },
      success: function(data) {
        shipping_dialog.dialog("close");
        location.reload();
      },
      fail: function(data) {
        alert(
          "We're sorry, but there was an error processing your request. Please refresh the page and try again. If the issue persists, please contact support."
        );
        location.reload();
      }
    });
  }
  
  function updateUserBilling() {
    var data = {};
    $("#gform_3")
      .serializeArray()
      .map(function(x) {
        data[x.name] = x.value;
      });
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "dc360_update_billing_address",
        update_data: data
      },
      success: function(data) {
        billing_dialog.dialog("close");
        location.reload();
      },
      fail: function(data) {
        alert(
          "We're sorry, but there was an error processing your request. Please refresh the page and try again. If the issue persists, please contact support."
        );
        location.reload();
      }
    });
  }
  
  $("#update-user-billing").on("click", function() {
    billing_dialog.dialog("open");
  });
  
  $("#update-user-shipping").on("click", function() {
    shipping_dialog.dialog("open");
  });
  
  $(document).ready(function() {
    $("#gform_submit_button_1").on("click", function(e) {
      e.preventDefault();
      updateUserInfo();
    });
    $("#gform_submit_button_2").on("click", function(e) {
      e.preventDefault();
      updateUserShipping();
    });
    $("#gform_submit_button_3").on("click", function(e) {
      e.preventDefault();
      updateUserBilling();
    });
  });

  
  $.fn.dataTableExt.oSort["time-date-sort-pre"] = function(value) {
    var parts = value.split("/");
    var year = parseInt(parts[2], 10);
    var month = parseInt(parts[0], 10);
    var day = parseInt(parts[1], 10);
    var dt = new Date(year, month - 1, day);
    return dt;
  };
  $.fn.dataTableExt.oSort["time-date-sort-asc"] = function(a, b) {
    return a - b;
  };
  $.fn.dataTableExt.oSort["time-date-sort-desc"] = function(a, b) {
    return b - a;
  };
  
  //downloads data table
  $("#download_table").show();
  var downloadTable = $("#download_table").DataTable({
    lengthChange: false,
    pageLength: 20,
    columnDefs: [
      {
        type: "time-date-sort",
        targets: [4]
      }
    ],
    language: {
      zeroRecords: "You have no reports or PDFs available.",
      emptyTable: "You have no reports or PDFs available."
    },
    drawCallback: function(settings) {
      if (
        $("#download_table > tbody > tr > td")
          .first()
          .hasClass("dataTables_empty")
      ) {
        $("#download_table_info").html("");
        $("#download_table_paginate").html("");
      }
    }
  });
  
  $(document).ready(function(e) {
    downloadTable.order([4, "desc"], [3, "desc"]).draw();
    $("#download_table_filter").remove();
    $("#download_table > thead > tr > th").unbind("click");
  });
  
  // fliters
  $("#download_search").on("keyup", function() {
    downloadTable
      .columns(0)
      .search(this.value)
      .order([4, "desc"], [3, "desc"])
      .draw();
  });
  
  $("ul.ir-filter.main > li").on("click", function() {
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      downloadTable
        .columns(1)
        .search("")
        .order([4, "desc"], [3, "desc"])
        .draw();
    } else {
      $("ul.main > li.selected").removeClass("selected");
      $(this).addClass("selected");
      downloadTable
        .columns(1)
        .search($(this).text())
        .order([4, "desc"], [3, "desc"])
        .draw();
    }
  });
  
  $(".year-filter").on("click", function() {
    if ($(this).hasClass("selected")) {
      $(this).removeClass("selected");
      downloadTable
        .columns(2)
        .search("")
        .order([4, "desc"], [3, "desc"])
        .draw();
    } else {
      $("ul.year > li.selected").removeClass("selected");
      $(this).addClass("selected");
      downloadTable
        .columns(2)
        .search($(this).text())
        .order([4, "desc"], [3, "desc"])
        .draw();
    }
  });
  
  $("#reset_filter").on("click", function() {
    downloadTable
      .search("")
      .columns()
      .search("")
      .order([4, "desc"], [3, "desc"])
      .draw();
    $("ul.ir-filter>li").each(function(i, obj) {
      $(this).removeClass("selected");
    });
    $("#download_search").val("");
  });
  
  $("#loadMoreRecentlyViewed").loadMoreResults({
    showItems: 3,
    displayedItems: 3,
    button: {
      class: "btn-load-more-recently-viewed"
    }
  });
  $("#loadMoreFavoriteContent").loadMoreResults({
    showItems: 3,
    displayedItems: 3,
    button: {
      class: "btn-load-more-favorite-content"
    }
  });
  $("#loadMoreLatestEcommerceNews").loadMoreResults({
    showItems: 3,
    displayedItems: 3,
    button: {
      class: "btn-load-more-latest-ecommerce-news"
    }
  });
  $("#loadMoreChartsAndData").loadMoreResults({
    showItems: 3,
    displayedItems: 3,
    button: {
      class: "btn-load-more-charts-and-data"
    }
  });
  
  $(document).on("click", ".favorite-button:NOT(.active) ", function(e) {
    var element = e.target;
    e.preventDefault();
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "dc360_add_favorite",
        scpostid: $(element).data("scpostid")
      },
      success: function(data) {
        $(element)
          .parent()
          .html(data);
      },
      fail: function(a, b) {}
    });
  });
  
  $(document).on("click", ".favorite-button.active", function(e) {
    var element = e.target;
    if ($(element).hasClass("fa")) {
      element = $(element).parent();
    }
    e.preventDefault();
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "dc360_remove_favorite",
        scpostid: $(element).data("scpostid")
      },
      success: function(data) {
        $(element)
          .parent()
          .html(data);
        $(element)
          .parent()
          .find(".favorite-button")
          .hide()
          .show(0);
      }
    });
  });
  
  var $loading = $('#loadingDiv').hide();
  $(document)
    .ajaxStart(function () {
      $loading.show();
    })
    .ajaxStop(function () {
      $loading.hide();
    });
  
  $(document).on("click", ".alphabetical-list-letter", function(e) {
  
    var element = e.target;
    e.preventDefault();
    $.ajax({
      cache: false,
      type: "POST",
      url: wp_ajax_url,
      data: {
        action: "post_start_with_letter",
        letter: $(element).attr('id')
      },
      success: function(data) {
        $('.list').html(data);
          
      }
    });
  });
  
/*
***Block: My account page End
*/
};
